import { NetworkToCurrency } from "../../helpers/currency-helpers";
import ConnectTron from "./connectTron";
import ConnectMetamask from "./connectMetamsk";
import { isMetaMaskInstalled } from "../../api/ethereum";
import { isTronLinkInstalled } from "../../api/tron";


const ConnectWallet = (props) => {
  const { to, amount, currency, network } = props;

  return (
    <>
      {
        NetworkToCurrency[network] === 'ETH' && isMetaMaskInstalled() ? <ConnectMetamask to={to} amount={amount} currency={currency} /> : null
      }

      {
        NetworkToCurrency[network] === 'TRX' && isTronLinkInstalled() ? <ConnectTron to={to} amount={amount} currency={currency} /> : null
      }
    </>
  );
};
export default ConnectWallet;
